<script>
import { mapGetters, mapActions } from 'vuex'
import DropDownActions from '@components/drop-down-action'

export default {
  name: 'DraftList',
  components: { DropDownActions },
  props: {
    actions: {
      type: Array,
      required: false,
      default: () => [],
    },
    call: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    marked: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      headers: ['#', 'name', 'description'],
    }
  },
  computed: {
    ...mapGetters('category', ['allCategories']),
  },
  methods: {
    ...mapActions('announcement', ['getCategories']),
    mark(id) {
      let marked = this.marked !== id ? id : 0
      this.call(marked)
    },
  },
}
</script>
<template>
  <div class="col-12 draft-campaign card">
    <table class="table card-body">
      <thead>
        <tr>
          <th v-for="header in headers" :key="header" class="text-capitalize">{{
            header
          }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="announcement in allCategories"
          :key="announcement.id"
          class="clickable"
          :class="{ active: marked === announcement.id }"
          @click.stop="mark(announcement.id)"
        >
          <td>{{ announcement.id }}</td>
          <td>{{ announcement.name }}</td>
          <td class="text-truncate" style="max-width: 200px;">{{
            announcement.description
          }}</td>
          <td>
            <DropDownActions :actions="actions" :param="announcement" />
          </td>
        </tr>
        <tr v-if="allCategories.length === 0">
          <td colspan="4"> No data for announcement </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
